import { notificaMessaggio } from './notifiche-utils';
export async function ConvertError(error: any, errorGenerico: string, isblob: boolean = false) {
  let errMes = `${errorGenerico}`;
  try {
    if (error?.error && error?.status == 500) {
      if (isblob) {
        const errorValue = await error.error.text();
        const blobError = JSON.parse(errorValue);
        errMes = blobError.title;
      } else if (error.error.title) {
        errMes = error.error.title;
      }
      else {
        const errT = error?.error?.text();
        const errj = JSON.parse(errT);
        errMes = errj.title;
      }
    } else if ( error?.status == 404) {
      errMes = error?.error;
    } else if (error?.status == 403) {
      errMes = 'Azione non consentita.';
    }
  } catch (ex) {
    console.warn(`Errore decodifica messaggio: ${ex}`);
  } finally {
    if ( error?.status != 404) {
      notificaMessaggio(errMes,'error');
      //notify(errMes, "error",3000);
    }
  }
  return errMes;
}